import { CalendarBlank, MapPin } from "@phosphor-icons/react";
import { EVENTS } from "@/lib/data";

export const EventsStrip = () => (
  <section
    data-testid="events-section"
    className="py-24 md:py-32 px-6 md:px-10 bg-brand-forest text-brand-ivory relative overflow-hidden"
  >
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.28em] font-semibold text-brand-gold mb-5 flex items-center gap-3">
            <span className="w-8 h-px bg-brand-gold" /> Community Corner
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">
            What&apos;s happening
            <span className="italic text-brand-gold"> at Exente.</span>
          </h2>
        </div>
        <p className="md:max-w-sm text-brand-ivory/70">
          From festivals to fitness camps, the calendar at Exente is always
          alive. RSVP at the management office or in the residents&apos; app.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {EVENTS.map((e, i) => (
          <article
            key={e.title}
            data-testid={`event-card-${i}`}
            className="group bg-brand-ivory text-brand-ink rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-500"
          >
            <div className="h-56 overflow-hidden">
              <img
                src={e.image}
                alt={e.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="p-7">
              <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-brand-leaf">
                <CalendarBlank size={14} weight="fill" />
                {e.date}
              </div>
              <h3 className="font-display text-2xl text-brand-forest mt-3">{e.title}</h3>
              <p className="text-brand-mute mt-3 text-sm leading-relaxed">
                {e.desc}
              </p>
              <div className="flex items-center gap-2 mt-5 text-sm text-brand-forest">
                <MapPin size={14} weight="light" /> {e.place}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
